import React from "react";
import { Grid, TextField, Autocomplete, Alert } from "@mui/material";
import { Service, CreateProcessRequest } from "../../../api/processes";
import { ProcessFormData, ProcessFormErrors } from "../types";
import { formGridStyles } from "../styles";

interface ProcessBasicInfoProps {
  formData: ProcessFormData;
  errors: ProcessFormErrors;
  services: Service[];
  loading: boolean;
  onChange: (field: keyof ProcessFormData) => (event: any) => void;
}

export const ProcessBasicInfo: React.FC<ProcessBasicInfoProps> = ({
  formData,
  errors,
  services,
  loading,
  onChange,
}) => {
  return (
    <Grid container spacing={2} sx={formGridStyles}>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="عنوان فرایند"
          value={formData.title}
          onChange={onChange("title")}
          error={!!errors.title}
          helperText={errors.title}
          margin="normal"
          required
          disabled={loading}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Autocomplete
          options={services}
          value={services.find((s) => s.id === formData.serviceRef) ?? null}
          onChange={(event, newValue) => {
            onChange("serviceRef")({ target: { value: newValue?.id ?? 0 } });
          }}
          getOptionLabel={(option) => option.name}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          renderInput={(params) => (
            <TextField
              {...params}
              label="خدمت"
              margin="normal"
              required
              error={!!errors.serviceRef}
              disabled={loading}
            />
          )}
          disabled={loading}
        />
        {errors.serviceRef && (
          <Alert severity="error" sx={{ mt: 1 }}>
            {errors.serviceRef}
          </Alert>
        )}
      </Grid>
    </Grid>
  );
};
